module.exports = __webpack_public_path__ + "static/img/iPhone.9e88cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/aboutus/img/iPhone.png
// module id = rzR8
// module chunks = 1